import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Well, ButtonToolbar } from '@sketchpixy/rubix'
import { FETCH_USER_BROADCASTS_REQUEST } from '../../actions/actions'
import InboxItem from './InboxItem'
import { browserHistory } from 'react-router'
import { BounceLoader } from 'halogen'
import { selectBroadcasts } from '../../selectors/messagesSelector'
import QueryAble from './SearchAndQueryBar'
//we are using same broadcast selector and reducer for both manager and other users

const styles = {
  spinner: {
    display: 'flex',
    height: '60vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
}

class BroadcastInbox extends Component {
  componentWillMount() {
    const {
      userType,
      dispatch,
      broadcastedMessages: { result: broadcastedMessages, isEverSynced },
    } = this.props

    if (userType === 'MANAGER') {
      browserHistory.push('/dashboard/messages/broadcasts')
    }

    if (
      userType !== 'MANAGER' &&
      (broadcastedMessages.length === 0 || isEverSynced === false)
    ) {
      dispatch({ type: FETCH_USER_BROADCASTS_REQUEST })
    }
  }

  render() {
    const {
      messageAsyncCall,
      broadcastedMessages: {
        count: messagesCount,
        entities: { broadcasts },
        result: broadcastedMessages,
      },
    } = this.props

    return (
      <div >
        <Well>
          <ButtonToolbar>
            <span>
              <span>اعلان های دریافتی از طرف مدیریت</span>
            </span>
          </ButtonToolbar>
        </Well>

        <QueryAble
          noQuery={true}
          itemsCount={messagesCount}
          collapsed={false}
          actionType={FETCH_USER_BROADCASTS_REQUEST}
        >
          {messageAsyncCall ? (
            <div style={styles.spinner}>
              <BounceLoader color={'#00abde'} />
            </div>
          ) : (
            <div className="message-page">
              {broadcastedMessages.map((messageId, i) => (
                <InboxItem
                  key={i}
                  type="broadcast"
                  massageId={messageId}
                  description={broadcasts[messageId].text}
                  date={broadcasts[messageId].sent_at}
                />
              ))}
            </div>
          )}
        </QueryAble>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userType: state.auth.userType,
    ...selectBroadcasts(state),
    messageAsyncCall: state.messages.aSyncCall,
  }
}

export default connect(mapStateToProps)(BroadcastInbox)



// WEBPACK FOOTER //
// ./src/components/common/BroadcastInbox.js